/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

export const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Avatar = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4b5563;
  border-radius: 50%;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  overflow: hidden;
`;

export const Name = styled.p`
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
}
`;

export const SubText = styled.p`
  font-size: 0.75rem;
  color: #9ca3af;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`;
